export const coinholdRoutes = [
  {
    path: "/coinhold",
    name: "Coinhold",
    component: () => import("@/views/Coinhold/Main.vue"),
    meta: { topLevel: true, menu: true, showDemoVersion: true },
  },
  {
    path: "/coinhold/new",
    name: "CoinholdNew",
    component: () => import("@/views/Coinhold/New.vue"),
    meta: { scrollTop: true },
  },
  {
    path: "/coinhold/choose-coin",
    name: "CoinholdChooseCoin",
    component: () => import("@/views/Coinhold/ChooseCoin.vue"),
    meta: { showDemoVersion: true },
  },
  {
    path: "/coinhold/item/:id",
    name: "CoinholdItem",
    component: () => import("@/views/Coinhold/Item.vue"),
  },
  {
    path: "/coinhold/item/:id/history",
    name: "CoinholdItemHistory",
    component: () => import("@/views/Coinhold/Item/History.vue"),
  },
  {
    path: "/coinhold/item/:id/topup",
    name: "CoinholdTopUp",
    component: () => import("@/views/Coinhold/Item/TopUp.vue"),
  },
  {
    path: "/coinhold/item/:id/withdraw",
    name: "CoinholdWithdraw",
    component: () => import("@/views/Coinhold/Item/Withdraw.vue"),
  },
  {
    path: "/coinhold/item/:id/withdraw/confirm",
    name: "CoinholdWithdrawConfirm",
    component: () => import("@/views/Coinhold/Item/ConfirmWithdraw.vue"),
  },
  {
    path: "/coinhold/item/:id/settings",
    name: "CoinholdSettings",
    component: () => import("@/views/Coinhold/Item/Settings.vue"),
  },
  {
    path: "/coinhold/item/:id/close",
    name: "CoinholdClose",
    component: () => import("@/views/Coinhold/Item/ConfirmClose.vue"),
  },
  {
    path: "/coinhold/success",
    name: "CoinholdSuccess",
    component: () => import("@/views/Coinhold/Item/Success.vue"),
  },
  {
    path: "/coinhold/history",
    name: "CoinholdHistory",
    component: () => import("@/views/Coinhold/History.vue"),
    meta: { parent: "CoinholdHistory", noBack: false },
  },
  {
    path: "/coinhold/calculator",
    name: "CoinholdCalculator",
    component: () => import("@/views/Coinhold/Calculator.vue"),
  },
];
